
import { defineComponent, ref } from 'vue';
import InnerLoader from '@/components/InnerLoader.vue';
import { CHANGE_FREQUENCY } from '../graphql/Mutations';
import { Apollo, Notify } from '@/core/services';
import { useI18n } from 'vue-i18n';

export default defineComponent({
    name: 'FrequencyChanging',
    components: {
        // Input,
        // Select,
        InnerLoader
    },

    setup(props, context) {
        const isVisible = ref(false);
        const loading = ref(false);
        const tenure = ref('');
        const next_order_date = ref('');
        const yesClicked = ref(false);
        const new_order_date = ref('');
        const subscription_id = ref('');
        const customer_id = ref('');
        const order_id = ref('');
        const subscribeValue = ref('');
        const dateError = ref(false);
        const frequencyError = ref(false);
        const i18n = useI18n();
        const subscribeOptions = ref([
            {
                value: 'WEEKLY',
                label: 'message.WEEKLY'
            },
            {
                value: 'TWO_WEEKS',
                label: 'message.TWO_WEEKS'
            },
            {
                value: 'MONTHLY',
                label: 'message.MONTHLY'
            },
            {
                value: 'TWO_MONTHS',
                label: 'message.TWO_MONTHS'
            },
            {
                value: 'THREE_MONTHS',
                label: 'message.THREE_MONTHS'
            }
        ]);

        const validateForm = () => {
            let isValid = true;

            if (!new_order_date.value) {
                dateError.value = true;
                isValid = false;
            } else {
                dateError.value = false;
            }

            if (!subscribeValue.value) {
                frequencyError.value = true;
                isValid = false;
            } else {
                frequencyError.value = false;
            }

            return isValid;
        };

        const show = subscription_data => {
            isVisible.value = true;
            document.body.style.overflow = 'hidden'; // Prevent scrolling when modal is open
            tenure.value = subscription_data?.order_subscription?.tenure;
            next_order_date.value = subscription_data?.order_subscription?.next_order_date;
            subscription_id.value = subscription_data?.order_subscription?.id;
            customer_id.value = subscription_data?.order_subscription?.customer_id;
            order_id.value = subscription_data?.order_subscription?.order_id;
        };

        const close = () => {
            isVisible.value = false;
            yesClicked.value = false;
            document.body.style.overflow = ''; // Re-enable scrolling
        };

        const save = () => {
            // Handle save logic here
            yesClicked.value = true;
            // close();
        };

        // Reset Form Data On Model Popup
        const resetForm = () => {
            isVisible.value = false;
            yesClicked.value = false;
            new_order_date.value = '';
            subscribeValue.value = '';
            loading.value = false;
        };

        // Submit handler Request
        const submitHandlerForm = async () => {
            if (validateForm()) {
                // Proceed with form submission

                loading.value = true;
                await Apollo.mutate({
                    mutation: CHANGE_FREQUENCY,
                    variables: {
                        next_order_date: new_order_date.value,
                        tenure: subscribeValue.value,
                        subscription_id: subscription_id.value,
                        customer_id: customer_id.value,
                        order_id: order_id.value
                    },
                    update: (store, { data: { update_order_frequency } }) => {
                        resetForm();
                        context.emit('frequency-updated', true); // Emit event to parent
                        Notify.success(`${i18n.t('message.RECORD_UPDATED_SUCCESSFULLY')}`);
                    }
                }).catch(() => {
                    loading.value = false;
                });
            }
        };

        const disablePreviousDates = (time: Date) => {
            // Disable all dates before today
            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        };

        return {
            isVisible,
            show,
            close,
            save,
            tenure,
            next_order_date,
            subscribeOptions,
            yesClicked,
            new_order_date,
            disablePreviousDates,
            subscribeValue,
            submitHandlerForm,
            dateError,
            frequencyError,
            validateForm,
            loading
        };
    }
});
